export default __webpack_public_path__ + "static/media/pdf_icon.eb53b17a.png";